/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-22 20:31:52
 * @LastEditTime: 2024-04-19 11:23:48
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\a_common\users.ts
 * @Description: 
 */
export const commonService = {
    getPortalInfo: '/portal/common/getPortalInfo',      // 获取门户设置信息
    eduBaseInfo: '/portal/common/eduBaseInfo',          // 获取教育局基础信息
    bureauInfo: '/portal/common/bureauInfo',            // 局端资讯信息
    bureauInfoDetail: '/portal/common/bureauInfoDetail',// 局端资讯详情
    getSchoolYearInfo: '/portal/common/getSchoolYearInfo',        // 获取学年信息

}
export const userService = {
    getUserInfo: '/portal/user/getUserInfo',            // 获取用户信息
}
export const schoolService = {
    getSchoolInfo: 'portal/homepage/getSchoolInfo',     // 获取学校信息
    infoSettings: 'portalManagement/infoSettings',      // 版权及联系我们       
}
